import { post, get } from './api'

export function getCRVData(token) {
  return get(`verification/crvVerification?token=${token}`)
}

export function sendCRV(values) {
  return post('verification/crvVerification', values)
}

export function checkSubjectAgreemen(values) {
  return post('request/checkSubjectAgreement', values)
}
export function checkSubjectCrvCompatibility(values) {
  return post('request/checkSubjectCrvCompatibility', values)
}

export function log(values) {
  return post('common/log', JSON.stringify(values))
}



// WEBPACK FOOTER //
// ./src/services/api/crv.js